// Third-party
import React from 'react';

// Components
import WarningModal from './WarningModal';

// Utils
import { formatMessage, FormattedHTMLMessage } from '@/utils/i18n';

// Constants
const defaultBody = 'DiscardPortfolio.Body';
const defaultTitle = 'DiscardPortfolio.Title';

type Props = {
  backdropClassName?: string;
  body?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
  show?: boolean;
  title?: string;
};

const DiscardPortfolioModal = ({ body, cancelLabel, confirmLabel, onCancel, onConfirm, show, title, ...rest }: Props) => (
  <WarningModal
    body={<FormattedHTMLMessage id={body || defaultBody} />}
    cancelLabel={cancelLabel}
    confirmLabel={confirmLabel ? formatMessage(confirmLabel) : undefined}
    onCancel={onCancel}
    onConfirm={onConfirm}
    show={show}
    title={formatMessage(title || defaultTitle)}
    {...rest}
  />
);

export default DiscardPortfolioModal;
